export enum COMPETITIONS_ADD_TABS {
    awards = 'awards',
    cgwave = 'cgwave',
    rules = 'rules',
    jury = 'jury',
    figurine = 'figurine',
    competitions = 'competitions'
}export enum COMPETITIONS_ADD_TABS {
    awards = 'awards',
    cgwave = 'cgwave',
    rules = 'rules',
    jury = 'jury',
    figurine = 'figurine',
    competitions = 'competitions'
}